import { Table } from '@tribeplatform/react-ui-kit/Table'

export const TableSkeleton = () => {
  return (
    <Table.Body className="bg-background">
      <Table.Row>
        <Table.Cell>
          <div className="h-4 bg-skeleton rounded-full" />
        </Table.Cell>
        <Table.Cell className="font-mono w-full truncate max-w-0">
          <div className="h-4 bg-skeleton rounded-full" />
        </Table.Cell>
        <Table.Cell>
          <div className="h-4 bg-skeleton rounded-full" />
        </Table.Cell>
        <Table.Cell align="center">
          <div className="h-5 w-5 bg-skeleton rounded-full" />
        </Table.Cell>
      </Table.Row>
    </Table.Body>
  )
}
